document.addEventListener('DOMContentLoaded', function() {
    const formContainer = document.getElementById('newsletter-form-container');
    const successMessage = document.getElementById('newsletter-success');
    const errorMessage = document.getElementById('newsletter-error');
    const dismissError = document.getElementById('dismiss-error');
    
    if (!formContainer) return;
    
    const form = formContainer.querySelector('form');
    if (!form) return;
    
    const isFormidable = form.classList.contains('frm-show-form');
    
    if (!isFormidable) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const nameInput = document.getElementById('newsletter-name');
            const emailInput = document.getElementById('newsletter-email');
            const submitButton = document.getElementById('newsletter-submit');
            
            if (!nameInput || !emailInput) {
                console.error('Name or email input field not found');
                showError();
                return;
            }
            
            if (!nameInput.value.trim() || !emailInput.value.trim()) {
                showError();
                return;
            }
            
            let originalText = submitButton ? submitButton.textContent : 'SUBSCRIBE';
            if (submitButton) {
                submitButton.innerHTML = `
                    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg> 
                    Subscribing...
                `;
                submitButton.disabled = true;
            }
            
            const formData = new FormData();
            formData.append('action', 'submit_newsletter');
            formData.append('name', nameInput.value.trim());
            formData.append('email', emailInput.value.trim());
            
            fetch(ajaxurl, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    showSuccess();
                } else {
                    console.error('Error from server:', data);
                    showError();
                }
            })
            .catch(error => {
                console.error('Fetch Error:', error);
                showError();
            })
            .finally(() => {
                if (submitButton) {
                    submitButton.innerHTML = originalText;
                    submitButton.disabled = false;
                }
            });
        });
    } else {
        // Handle Formidable Form
        const formElements = form.querySelectorAll('input, select, textarea, button');
        formElements.forEach(element => {
            if (element.type === 'text' || element.type === 'email') {
                element.classList.add('w-full', 'h-12', 'px-4', 'rounded-lg', 'bg-white/90', 'text-gray-800', 'border-0', 'focus:ring-2', 'focus:ring-secondary');
            } else if (element.type === 'submit' || element.tagName.toLowerCase() === 'button') {
                element.classList.add('w-full', 'md:w-auto', 'h-12', 'px-6', 'bg-secondary', 'hover:bg-secondary/90', 'rounded-lg', 'text-white', 'font-semibold', 'transition-all', 'duration-300', 'hover:scale-105');
            }
        });
        
        const fieldsContainer = form.querySelector('.frm_fields_container');
        if (fieldsContainer) {
            fieldsContainer.classList.add('flex', 'flex-col', 'md:flex-row', 'gap-4');
            
            const fieldContainers = fieldsContainer.querySelectorAll('.frm_form_field');
            fieldContainers.forEach(container => {
                container.classList.add('flex-1');
                
                const label = container.querySelector('label');
                if (label) {
                    label.style.display = 'none';
                }
            });
            
            const submitContainer = fieldsContainer.querySelector('.frm_submit');
            if (submitContainer) {
                submitContainer.classList.add('md:w-auto');
            }
        }
        
        // Listen for form submission success/error
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const formSuccess = form.querySelector('.frm_message');
                    if (formSuccess) {
                        showSuccess();
                        formSuccess.style.display = 'none';
                    }
                    
                    const formError = form.querySelector('.frm_error_style');
                    if (formError) {
                        showError();
                        formError.style.display = 'none';
                    }
                }
            });
        });
        
        observer.observe(form, { childList: true, subtree: true });
    }
    
    function showSuccess() {
        if (successMessage) {
            form.style.opacity = '0';
            form.style.visibility = 'hidden';
            setTimeout(() => {
                form.style.display = 'none';
                successMessage.style.opacity = '1';
                successMessage.style.visibility = 'visible';
                successMessage.style.transform = 'scale(1)';
                
                setTimeout(() => {
                    successMessage.style.opacity = '0';
                    successMessage.style.visibility = 'hidden';
                    successMessage.style.transform = 'scale(0.95)';
                    
                    setTimeout(() => {
                        form.style.display = '';
                        form.style.opacity = '1';
                        form.style.visibility = 'visible';
                        form.reset();
                    }, 300);
                }, 5000);
            }, 300);
        }
    }
    
    function showError() {
        if (errorMessage) {
            form.style.opacity = '0';
            form.style.visibility = 'hidden';
            setTimeout(() => {
                form.style.display = 'none';
                errorMessage.style.opacity = '1';
                errorMessage.style.visibility = 'visible';
                errorMessage.style.transform = 'scale(1)';
                
                setTimeout(() => {
                    errorMessage.style.opacity = '0';
                    errorMessage.style.visibility = 'hidden';
                    errorMessage.style.transform = 'scale(0.95)';
                    
                    setTimeout(() => {
                        form.style.display = '';
                        form.style.opacity = '1';
                        form.style.visibility = 'visible';
                        form.reset();
                    }, 300);
                }, 5000);
            }, 300);
        }
    }
    
    if (dismissError) {
        dismissError.addEventListener('click', function() {
            errorMessage.style.opacity = '0';
            errorMessage.style.visibility = 'hidden';
            errorMessage.style.transform = 'scale(0.95)';
            
            setTimeout(() => {
                form.style.display = '';
                form.style.opacity = '1';
                form.style.visibility = 'visible';
                form.reset();
            }, 300);
        });
    }
});